module.exports = __webpack_public_path__ + "img/deleted.42b7e675.svg";